<template>
  <div>
    <b-card no-body>

      <b-row class="m-2">
        <b-col cols="12">
          <h3 class="text-center mb-1">
            {{ $t("Received applied applications by organizations") }}
          </h3>
          <v-select
            id="direction"
            v-model="periodId"
            :reduce="(option) => option.id"
            :options="periods"
            :get-option-label="(option) => option.name"
            :placeholder="$t('Period')"
            @input="search()"
          />
        </b-col>
      </b-row>
    </b-card>
    <b-card
      v-if="periodId"
      no-body
    >
      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="8"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          />

          <!-- Search -->
          <b-col
            cols="12"
            md="4"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                :placeholder="$t('Search...')"
              />
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="applyDocCountByOrganizationTable"
        :items="appliedDocCountByOrganization"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        :empty-text="$t('No matching records found')"
        :busy="isBusy"
        :filter="searchQuery"
        class="position-relative"
      >
        <template #head(name)="data">
          {{ $t(data.label) }}
        </template>

        <!-- Column: Id -->
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>

        <template #cell(name)="data">
          <b-link :to="{ name: 'applied-doc-count-by-direction', params: { orgId: data.item.id, periodId: periodId } }">
            {{ $langName(data.value) }}
          </b-link>
        </template>

      </b-table>
    </b-card>
  </div>

</template>

<script>
import {
  BCard, BTable, BRow, BCol, BFormInput, BLink,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import vSelect from 'vue-select'
import store from '@/store'
import statisticModule from '@/store/statistic'
import periodModule from '@/store/period'

export default {
  name: 'AppliedDocCountByOrganization',
  components: {
    BCard,
    BTable,
    BRow,
    BCol,
    BFormInput,
    vSelect,
    BLink,
  },
  data() {
    return {
      periodId: null,
    }
  },
  computed: {
    appliedDocCountByOrganization() {
      return this.$store.state[this.MODULE_NAME].appliedDocCountByOrganization
    },
    periods() {
      return this.$store.state[this.MODULE_PERIOD].periods
    },
    applyDocumentStatuses() {
      return this.$store.state.staticModule.applyDocumentStatuses
    },
    applyDocumentDcTypes() {
      return this.$store.state.staticModule.dcTypes
    },
  },
  created() {
    this.refetchData()
    this.loadPeriods()
  },
  methods: {
    refetchData() {
      if (this.periodId) {
        this.isBusy = true
        this.$store.dispatch(`${this.MODULE_NAME}/appliedDocCountByOrganization`, { period_id: this.periodId }).then(() => {
          this.isBusy = false
        })
      }
    },
    loadPeriods() {
      this.$store.dispatch(`${this.MODULE_PERIOD}/list`)
    },
    search() {
      this.refetchData()
    },
    getApplyDocumentDcTypes(id) {
      return this.$store.getters['staticModule/getDcType'](id)
    },
  },
  setup() {
    const MODULE_NAME = 'statisticFront'
    const MODULE_PERIOD = 'periodFront'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, statisticModule)
    if (!store.hasModule(MODULE_PERIOD)) store.registerModule(MODULE_PERIOD, periodModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_PERIOD)
    })

    const {
      DSc,
      PhD,
      traineeResearcher,
      independentResearcherDSc,
      independentResearcherPhD,
      targetedPhD,
      targetedDSc,
      dcTypes,
    } = store.state.staticModule

    const statuses = [
      DSc,
      PhD,
      traineeResearcher,
      independentResearcherDSc,
      independentResearcherPhD,
      targetedPhD,
      targetedDSc,
    ]
    const tableColumns = [
      { key: 'index', label: '#' },
      { key: 'name', label: 'name' },
    ]
    dcTypes.forEach(x => {
      if (statuses.includes(x.id)) {
        tableColumns.push({ key: `${x.id}`, label: `${x.name.uz}` })
      }
    })
    const isBusy = false
    const searchQuery = ''

    return {
      tableColumns,
      isBusy,
      searchQuery,
      MODULE_NAME,
      MODULE_PERIOD,
      statuses,
    }
  },
}
</script>

<style scoped>

</style>
